import {
  mapState
} from "vuex";

export default {
  computed: {
    ...mapState({
      roleUserData: state => state.main.userData,
      managerStorage: state => state.storage.managerStorage,
    })
  },
  data() {
    return {

    }
  },
  methods: {
    // 修改当前选中的侧边栏
    setNavType(project) {
      if (project.type == 3 || project.type == 4) {
        this.$store.commit("SET_TYPE", {
          main: "project",
          sub: "slist",
        });
      } else if (project.wxType == "A") {
        this.$store.commit("SET_TYPE", {
          main: "project",
          sub: "alist",
        });
      }
    },
  },
  watch: {

  }
}



// WEBPACK FOOTER //
// ./src/page/project/mixins/objectUtil.js